export interface IapGemPackDef {
  productId: string;       // RevenueCat/App Store product ID
  gems: number;            // Gems awarded on purchase
  priceUsd: number;        // Fallback display price (actual price comes from App Store via RevenueCat)
  label: string;           // Display label
  bestValue?: boolean;     // Badge flag for largest pack
}

export const IAP_GEM_PACKS: readonly IapGemPackDef[] = [
  { productId: "gems_50",   gems: 50,   priceUsd: 0.99,  label: "50 Gems" },
  { productId: "gems_275",  gems: 275,  priceUsd: 4.99,  label: "275 Gems" },
  { productId: "gems_600",  gems: 600,  priceUsd: 9.99,  label: "600 Gems" },
  { productId: "gems_1500", gems: 1500, priceUsd: 19.99, label: "1,500 Gems", bestValue: true },
];

export function getIapPackByProductId(productId: string): IapGemPackDef | undefined {
  return IAP_GEM_PACKS.find(p => p.productId === productId);
}
